import { useCallback, useContext } from "react";
import { useSWRConfig } from "swr";
import { BoardMachinesStates } from "../../../../../reducers/uploadedBoard";
import settings from "../../../../../constants/settings";
import { BoardIdContext, BoardShipmentIds } from "./reviewBoardFlowLoader";

export function boardFilesKey(boardId: string) {
  return `${settings.api_url}/boards/${boardId}/files`;
}

/**
 * Keeps the files listing current from the board's websocket state updates.
 * The manufacturing output moves through its states on the worker, so each
 * change (generating, generated, or reset to out of date by a board change)
 * refetches the listing wherever it is being shown.
 */
export default function useRefreshBoardFiles() {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const { mutate } = useSWRConfig();

  const handleManufacturingOutputStateUpdates = useCallback(
    (nextStatesData: BoardMachinesStates, states: BoardMachinesStates) => {
      if (
        nextStatesData.manufacturing_output_state !==
        states.manufacturing_output_state
      ) {
        // A no-op when nothing is subscribed to the listing.
        void mutate(boardFilesKey(boardId));
      }
    },
    [boardId, mutate],
  );

  return {
    handleManufacturingOutputStateUpdates,
  };
}
